import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { getCurrentUser } from "../../reducers/login";
import LessonsGroupList from '../../components/RoleBased/LessonsGroupList';
import { fetchGroups, getGroups, getIsGroupLoading, fetchCreateGroup } from "../../reducers/group";
import { bindActionCreators } from "redux";

const LessonsGroupListContainer = (props) => {
    const { currentUser } = props;
    return (currentUser.optional.groups || currentUser.optional.role === 'admin' ?
        <LessonsGroupList {...props} />
        :
        <Redirect to="noAccess" />)
}
const mapState = (state) => ({
    currentUser: getCurrentUser(state),
    groups: getGroups(state),
    isLoading: getIsGroupLoading(state),
});
const actions = (dispatch, props) => ({
    fetchGroups: bindActionCreators(fetchGroups, dispatch),
    createGroup: bindActionCreators(fetchCreateGroup, dispatch),
});

export default connect(mapState, actions)(LessonsGroupListContainer);
